"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Check = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Check"));
var _htmlCheck = _interopRequireDefault(require("@berlitz/max-utils/lib/htmlCheck"));
var _Checkbox = require("./Checkbox.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);
  var _super = _createSuper(Checkbox);
  function Checkbox() {
    var _temp, _this;
    _classCallCheck(this, Checkbox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      nativeCheckBox: true
    }, _this.componentDidMount = function () {
      return _this.setState({
        nativeCheckBox: false
      });
    }, _temp));
  }
  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        checked = _this$props.checked,
        label = _this$props.label,
        name = _this$props.name,
        onChange = _this$props.onChange,
        value = _this$props.value,
        required = _this$props.required,
        light = _this$props.light,
        hideLabel = _this$props.hideLabel,
        className = _this$props.className;
      return /*#__PURE__*/_react.default.createElement(_Checkbox.Label, {
        checked: checked,
        "data-key": "max-checkbox",
        className: className
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.Input, {
        id: id,
        checked: checked,
        "data-key": "max-checkbox__input",
        name: name,
        onChange: onChange,
        required: required,
        type: "checkbox",
        value: value,
        native: this.state.nativeCheckBox
      }), /*#__PURE__*/_react.default.createElement(_Checkbox.Container, {
        checked: checked
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.IconWrapper, {
        checked: checked
      }, /*#__PURE__*/_react.default.createElement(_Check.default, {
        size: "xs",
        color: "brand03",
        "data-key": "max-checkbox__tick"
      }))), /*#__PURE__*/_react.default.createElement(_Checkbox.LabelText, {
        "data-key": "max-checkbox__label",
        light: light,
        hideLabel: hideLabel,
        isRequired: required
      }, _htmlCheck.default.test(label) ? /*#__PURE__*/_react.default.createElement(_Checkbox.RichTextLabel, {
        dangerouslySetInnerHTML: {
          __html: label
        },
        inverse: light
      }) : label, required && hideLabel && /*#__PURE__*/_react.default.createElement(_Checkbox.Asterisk, {
        light: light
      }, " *")));
    }
  }]);
  return Checkbox;
}(_react.default.Component);
Checkbox.defaultProps = {
  onChange: function onChange() {},
  checked: false,
  required: false,
  light: false
};
var _default = Checkbox;
exports.default = _default;